import { PendoScreenInventory } from '@pendo/components-vue3';
import { MAX_LABELS } from './screen-inventory.constants';
import type { InventoryCandidate } from './screen-inventory.types';
import { isText } from './screen-inventory.utils';

interface TableDescription {
    title: string;
    columns: Array<{ label: string }>;
    rowCount: number;
    sort: { label: string; direction: 'ascending' | 'descending' } | null;
    loading: boolean;
}

interface TableEntry {
    element: Element;
    describe: () => TableDescription;
}

function count (amount: number, noun: string): string {
    return `${amount} ${amount === 1 ? noun : `${noun}s`}`;
}

function toCandidate ({ element, describe }: TableEntry): InventoryCandidate {
    const { title, columns, rowCount, sort, loading } = describe();
    const labels = columns.map((column) => column.label).filter(isText);
    const shape = [count(rowCount, 'row'), count(labels.length, 'column'), ...(loading ? ['loading'] : [])];

    return {
        element,
        kind: 'table',
        ...(isText(title) && { title }),
        ...(labels.length && { fallbackName: labels[0] }),
        shape: shape.join(', '),
        ...(sort && isText(sort.label) && { details: [{ name: `sorted ${sort.direction} by`, text: sort.label }] }),
        labelsOf: 'columns',
        labels: labels.slice(0, MAX_LABELS).map((text) => ({ text })),
        labelTotal: labels.length,
    };
}

export function collectTableCandidates (): InventoryCandidate[] {
    const entries: TableEntry[] = PendoScreenInventory.getEntries();

    return entries.map(toCandidate);
}
